import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { I18nService } from '../services/prod/i18n.service'

@Injectable()
export class LangInterceptor implements HttpInterceptor {
  isEng: string

  constructor(private i18nService: I18nService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.isEng = this.i18nService.isEng() ? 'en' : 'ru'

    const copiedRequest = request.clone({
      headers: request.headers.set('lang', this.isEng)
    })

    return next.handle(copiedRequest)
  }
}
